export const biPanel = 'card';

export const biPanelMuted = 'rounded-lg border border-slate-200 bg-slate-50 p-3';

export const biAccent = {
  emerald: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  cyan: 'border-cyan-200 bg-cyan-50 text-cyan-800',
  purple: 'border-violet-200 bg-violet-50 text-violet-800',
  amber: 'border-amber-200 bg-amber-50 text-amber-800',
  rose: 'border-rose-200 bg-rose-50 text-rose-800',
  sky: 'border-sky-200 bg-sky-50 text-sky-800',
};

export const chartTooltipStyle = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: 8,
  color: '#0f172a',
  fontSize: 13,
};

/** Shared Recharts axis tick style — keep BI charts readable */
export const chartAxisTick = { fontSize: 14, fill: '#334155' };
export const chartAxisTickMuted = { fontSize: 13, fill: '#475569' };

export const formatNpr = (value) => {
  const num = Number(value) || 0;
  return `Rs. ${num.toLocaleString('en-NP', { maximumFractionDigits: 0 })}`;
};

export const formatPct = (value, digits = 1) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `${num.toFixed(digits)}%`;
};

export const formatNumber = (value) => {
  const num = Number(value) || 0;
  return num.toLocaleString('en-NP');
};

export const calcLiftPct = (promo, baseline) => {
  if (!baseline) return 0;
  return ((promo - baseline) / baseline) * 100;
};

export const calcCumulative = (days, upToDay) => {
  const slice = days.slice(0, Math.max(0, upToDay));
  return slice.reduce(
    (acc, day) => ({
      sales: acc.sales + (day.sales || 0),
      quantity: acc.quantity + (day.quantity || 0),
      discountCost: acc.discountCost + (day.discountCost || 0),
    }),
    { sales: 0, quantity: 0, discountCost: 0 }
  );
};
